import React from 'react';


class RuleFollowUpEvent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if(this.props.onlyDescription) {
            return <li></li>;
        }
        return (
            <div className="list-group-item blue-grey-500">
                <div>Send to customers who received e-mail id <strong>#{this.props.rule.value}</strong></div>
            </div>
        );
    }


}

export default RuleFollowUpEvent;




// WEBPACK FOOTER //
// ./components/builder/RuleFollowUpEvent.js